import { render, staticRenderFns } from "./CustomerCommunication.vue?vue&type=template&id=0d97951a&scoped=true&lang=pug&"
import script from "./CustomerCommunication.vue?vue&type=script&lang=js&"
export * from "./CustomerCommunication.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCommunication.vue?vue&type=style&index=0&id=0d97951a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97951a",
  null
  
)

/* custom blocks */
import block0 from "./CustomerCommunication.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports